var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row gutter-sm" },
    [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12" },
        [
          _c("q-alert", { attrs: { color: "info", icon: "fas fa-users" } }, [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(_vm.$t("online_users")) +
                ": " +
                _vm._s(_vm.onlineQuantity) +
                "\n\t\t"
            )
          ])
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-4" },
        [
          _c("chat", {
            attrs: {
              id_webcast: _vm.id_webcast,
              type_chat: "moderation",
              order: "t"
            },
            on: { click_chat: _vm.clickChat }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-4" },
        [
          _c("chat", {
            attrs: {
              id_webcast: _vm.id_webcast,
              type_chat: "public",
              order: "t"
            },
            on: { click_chat: _vm.clickChat }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-4" },
        [
          _c("chat", {
            attrs: {
              id_webcast: _vm.id_webcast,
              type_chat: "disapprove",
              order: "td"
            },
            on: { click_chat: _vm.clickChat }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12" },
        [
          _c("q-input", {
            attrs: { "float-label": _vm.$t("new_message") },
            on: {
              keydown: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.sendMessage()
              }
            },
            model: {
              value: _vm.new_message,
              callback: function($$v) {
                _vm.new_message = $$v
              },
              expression: "new_message"
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "row gutter-sm " }, [
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-3",
              class: _vm.getOrder("cancel")
            },
            [
              _c("q-btn", {
                staticClass: "full-width",
                attrs: {
                  color: "tertiary",
                  label: _vm.$t("back"),
                  icon: "fas fa-chevron-left"
                },
                on: {
                  click: function($event) {
                    return _vm.hideModal()
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
            [
              _c("q-btn", {
                staticClass: "full-width",
                attrs: {
                  color: "secondary",
                  label: _vm.$t("send"),
                  icon: "far fa-comment-dots"
                },
                on: {
                  click: function($event) {
                    return _vm.sendMessage()
                  }
                }
              })
            ],
            1
          )
        ])
      ]),
      _c(
        "q-dialog",
        {
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "tertiary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.show_dialog = false
                      }
                    }
                  }),
                  _vm.type_chat === "public" || _vm.type_chat === "moderation"
                    ? _c("q-btn", {
                        attrs: {
                          color: "negative",
                          label: _vm.$t("disapprove")
                        },
                        on: {
                          click: function($event) {
                            return _vm.reproveChat()
                          }
                        }
                      })
                    : _vm._e(),
                  _vm.type_chat === "moderation" ||
                  _vm.type_chat === "disapprove"
                    ? _c("q-btn", {
                        attrs: { color: "positive", label: _vm.$t("approve") },
                        on: {
                          click: function($event) {
                            return _vm.approveChat()
                          }
                        }
                      })
                    : _vm._e()
                ]
              }
            }
          ]),
          model: {
            value: _vm.show_dialog,
            callback: function($$v) {
              _vm.show_dialog = $$v
            },
            expression: "show_dialog"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t(_vm.getTitle())))
          ]),
          _c("span", { attrs: { slot: "body" }, slot: "body" }, [
            _vm._v("\n\t\t\t" + _vm._s(_vm.chat.m) + "\n\t\t")
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }